import React, { useState } from 'react';

import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';

import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';

const DigitalPolicy = () => {
  const { endorsement_body, updateEndorsementBody, nextStep } =
    useEndorsementsDataContext();
  const { user } = useAuthDataContext();
  const { email } = user;
  const [gwCheck, setGwCheck] = useState(
    endorsement_body?.gw_digital_email !== undefined
      ? endorsement_body.gw_digital_email
      : true
  );
  const [gwDigitalEmail, setGwDigitalEmail] = useState(email);

  const updateEndorsement = () => {
    updateEndorsementBody({
      gw_digital_email: gwCheck ? gwDigitalEmail : undefined,
    });
    dataLayerPush('modificar_poliza_suscripcion', user?.id, {
      fieldName: 'suscripcion_poliza_digital',
      fieldValue: gwCheck,
    });
    nextStep();
  };

  return (
    <>
      <Grid container>
        <>
          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Box my={3}>
              <Typography variant="h6">
                {' '}
                Suscribite a la póliza digital{' '}
              </Typography>
              <Typography> Y recibila en tu casilla </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box my={3}>
              <FormControl component="fieldset">
                <RadioGroup
                  name={'gw_digital_email_check'}
                  aria-label="has"
                  value={gwCheck}
                  onChange={(event) =>
                    setGwCheck(event.target.value === 'true')
                  }
                  row
                >
                  {/* owner / vehicle_third / pedestrian */}
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Si"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          {gwCheck && (
            <Grid item xs={12} sm={7}>
              <Box my={2}>
                <Typography variant="caption">Email</Typography>
              </Box>
              <Box mr={2}>
                <TextField
                  size="small"
                  fullWidth={true}
                  name="gw_digital_email"
                  id="gw_digital_email"
                  placeholder="Ingresá el email"
                  variant="outlined"
                  onChange={(event) => setGwDigitalEmail(event.target.value)}
                  value={gwDigitalEmail}
                />
              </Box>
            </Grid>
          )}
        </>
        <Grid item xs={12} sm={6}>
          <Box my={3} display="flex" justifyContent="center">
            <Button
              onClick={updateEndorsement}
              variant="contained"
              color="primary"
              //disabled={gwDigitalEmail === user.email}
            >
              Continuar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DigitalPolicy;
